import React, { Component } from 'react';
import '../../static/css/App.css';
import '../../static/css/vendor-styles.css';
import { fetchRoutesForUser } from '../../redux/actions/userAction';
import { megaDispatch } from '../../redux/actions/megaDispatch';
import { switchDispatch } from '../../redux/actions/switchDispatch';
import {connect} from 'react-redux';
import Header from '../Layout/Header';
import SideMenu from '../Layout/Sidebar/Menu';
import Routes from './Routes';
import {BrowserRouter as Router, withRouter} from 'react-router-dom'
import ChooseClientRoutes from './ChooseClientRoutes';
import heartbeats from 'heartbeats'
import Idle from 'react-idle'

class App extends Component {

    componentDidMount () {
        this.props.switchDispatch('megaDispatch', this.props.clientPath, {}, this.props.user.user_id, this.props.user.user_token, true, this.props.user.user_profile.selectedRepresentativeUserId)
    }

    setHeartbeat(idle) {
        const app = this;
        if(idle) {
            this.heartbeat = heartbeats.createHeart(1000, 'refreshHeart');
            this.heartbeat.createEvent(60, {name: 'dispatchHeartbeat', countTo: 0}, function(count, last){
                app.props.switchDispatch('megaDispatch', app.props.clientPath, {}, app.props.user.user_id, app.props.user.user_token, false, app.props.user.user_profile.selectedRepresentativeUserId)
            });
        } else {
        	if(this.heartbeat) {
        		this.heartbeat.kill();
        	}
        }
    }

    render() {
        return (
            <div>
                <Router>
                    <div>
                        <Idle timeout={10000} onChange={({ idle }) => this.setHeartbeat(idle)} />
                        <div className="sidebar sidebar--dp">
                            {/*<HeaderLogoWithMenu toggleMenu={this.toggleMenu}/>*/}
                            <SideMenu/>
                        </div>

                        <div className="pagecontent pagecontent--main">
                            <Header />
                            <div className="pagecontent pagecontent--padded pagecontent--full">

                                {this.props.user && this.props.user.user_profile && Number(this.props.user.user_profile.is_representative) === 1 && Number(this.props.user.user_profile.selected_client_to_represent) === 0 ?

                                <ChooseClientRoutes />
                                : <Routes />
                                }

                            </div>
                        </div>
                    </div>
                </Router>
            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
    user: state.UserReducer,
    clientPath: state.ClientPathReducer.clientPath
  }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchRoutesForUser: (url, user_id, user_token) => dispatch(fetchRoutesForUser(url, user_id, user_token)),
        megaDispatch: (clientPath, user_id, user_token) => dispatch(megaDispatch(clientPath, user_id, user_token)),
        switchDispatch : (action, clientPath, data, user_id, user_token, showEditProgress, selectedRepresentativeUserId) => dispatch(switchDispatch(action, clientPath, data, user_id, user_token, showEditProgress, selectedRepresentativeUserId))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/components/Application/index.js